import React from "react";

import { Modal , ModalHeader , Button , ModalBody } from "reactstrap";
import photoRules from "../../../../../src/images/candidate/photo-rules.jpg";



export default function RulesofImage ({ isOpen = false, toggle = () => { } }) {
    return <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="quick-pages emplyoess-views"
    >
        <ModalHeader>
            {" "}
            Rules for photos
            <Button
                onClick={() => toggle()}
            >
                <i className="fa fa-times" aria-hidden="true"></i>
            </Button>
        </ModalHeader>
        <ModalBody>
            <div className="rules-modal">
                <h4> Your photo must be: </h4>
                <ul className="rules-lists">
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
                        clear and in focus
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> in
                        colour
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
                        unaltered by computer software ( DO NOT use filters)
                    </li>
                </ul>
                <h4> Your photo must show:</h4>
                <ul className="rules-lists">
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
                        contain no other objects or people
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> be
                        taken against a plain light-coloured background
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> be
                        in clear contrast to the background
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> not
                        have 'red eye'
                    </li>
                </ul>
                <h4>In your photo you must:</h4>
                <ul className="rules-lists">
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> be
                        facing forward and looking straight at the camera
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
                        have a plain expression and your mouth closed
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
                        have your eyes open and visible
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> not
                        have hair in front of your eyes
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> not
                        have a head covering (unless it's for religious or medical
                        reasons)
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> not
                        have anything covering your face
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> not
                        have any shadows on your face or behind you
                    </li>
                    <li>
                        <i className="fa fa-caret-right" aria-hidden="true"></i> Do
                        not wear glasses in your photo unless you have to do so. If
                        you must wear glasses, they cannot be sunglasses or tinted
                        glasses, and you must make sure your eyes are not covered by
                        the frames or any glare, reflection or shadow.
                    </li>
                </ul>
                <img src={photoRules} alt="" />
            </div>
        </ModalBody>
        {/* <ModalFooter>
        <button className="deatils-saves subs-cancel" type="button" onClick={() => this.setState(prevState => ({showPhotoRules: !prevState.showPhotoRules}))}> Cancel </button>
    </ModalFooter> */}
    </Modal>
}